import React from "react";
import Loader from "../components/common/Loader";
import Menu from "../components/home1-rtl/Menu";
import Navbar from "../components/home1-rtl/Navbar";
import Footer from "../components/home1-rtl/Footer";
import Header from "../components/home1-rtl/Header";
import Experience from "../components/home1-rtl/Experience";
import Services from "../components/home1-rtl/Services";
import Process from "../components/home1-rtl/Process";
import Projects from "../components/home1-rtl/Projects";
import Testimonials from "../components/home1-rtl/Testimonials";
import Chat from "../components/home1-rtl/Chat";
import { Helmet } from "react-helmet";

function Home1RTL() {
  React.useEffect(() => {
    try {
      const dir = "rtl";
      document.documentElement.lang = "ar";
      document.documentElement.dir = dir;

      // Dynamically load the RTL CSS
      const rtlStylesheet = document.createElement("link");
      rtlStylesheet.rel = "stylesheet";
      rtlStylesheet.type = "text/css";
      rtlStylesheet.href = "/common/assets/css/lib/bootstrap.rtl.min.css";
      document.head.appendChild(rtlStylesheet);
      const ltrStylesheet = document.getElementById("bootstrapLTRCSS");
      document.head.replaceChild(rtlStylesheet, ltrStylesheet);
      // Clean up: Remove the stylesheet if component unmounts
      return () => {
        document.head.removeChild(rtlStylesheet);
      };
    } catch (error) {}
  }, []);

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="تعمير للبناء والتطوير تقدم خدمات هندسية متكاملة تشمل التصميم الداخلي والخارجي، الإنتاج المخصص للأثاث، والاستشارات والإشراف على المشاريع، مع التركيز على الابتكار والاستدامة."
        />
        <meta
          name="keywords"
          content="تعمير, البناء والتطوير, تصميم داخلي, تصميم خارجي, إنتاج الأثاث, استشارات المشاريع, شركات البناء في مصر, حلول معمارية, تصاميم ثلاثية الأبعاد, الاستدامة في العمارة, تصميم معماري مبتكر, إدارة المشاريع الإنشائية"
        />
        <script src="/common/assets/js/common_js.js"></script>
        <script src="/home1/assets/js/home_1_scripts.js"></script>
        <link
          rel="preload"
          as="image"
          href="/home1/assets/img/head_slide1.webp"
        />
      </Helmet>
      <div className="home-style1">
        <Loader />
        <Menu />
        <div className="smooth-scroll-content" id="scrollsmoother-container">
          <Navbar />
          <Header />
          <main>
            <Experience />
            <Services />
            <Process />
            <Projects />
            <Testimonials />

            <Chat />
          </main>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default Home1RTL;
